<template>
    <div class="luca-card">
        <div class="card-img">
            <img :src="data.imageUrl" alt="card-img">
        </div>
        <div class="card-content">
            <p class="increasing-number">{{ animatedNumber.toFixed(0) }}</p>
            <h3>{{data.title}}</h3>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LucaConnectionCard',
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            animatedNumber: 0,
        };
    },
    watch: {
        'data.number': function(newVal, oldVal) {
            this.animateNumber();
        },
    },
    methods: {
        animateNumber() {
            let startValue = 0;
            const endValue = this.data.number;
            const duration = 2000;

            const startTime = performance.now();

            const animate = (currentTime) => {
                const elapsedTime = currentTime - startTime;
                const progress = Math.min(elapsedTime / duration, 1);
                this.animatedNumber = progress * (endValue - startValue) + startValue;

                if (progress < 1) {
                    requestAnimationFrame(animate);
                }
            };

            requestAnimationFrame(animate);
        },
    },
    mounted() {
        this.animateNumber();
    },
};
</script>


